"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SearchParamSchema = {
    $id: 'searchParam',
    oneOf: [
        {
            $id: 'simple-comparison',
            // Simple case: equality comparison of a non-object type
            type: [
                'string',
                'number',
                'array',
                'boolean',
                'null',
            ],
        },
        {
            // Various matchers and operators - to keep things simple, one
            // operator per object (you can always "and" them together)
            type: 'object',
            $id: 'operator',
            minProperties: 1,
            maxProperties: 1,
            additionalProperties: false,
            properties: {
                gt: {
                    type: 'number',
                },
                lt: {
                    type: 'number',
                },
                gte: {
                    type: 'number',
                },
                lte: {
                    type: 'number',
                },
                in: {
                    type: 'array',
                },
                not_in: {
                    type: 'array',
                },
                like: {
                    type: 'string',
                },
                not_like: {
                    type: 'string',
                },
                before: {
                    type: 'string',
                },
                after: {
                    type: 'string',
                },
                eq: {
                    type: [
                        'string',
                        'number',
                        'array',
                        'boolean',
                        'null',
                    ],
                },
                not_eq: {
                    type: [
                        'string',
                        'number',
                        'array',
                        'boolean',
                        'null',
                    ],
                },
                empty: {
                    type: 'boolean',
                },
            },
        },
    ],
};
const SearchSchema = {
    type: 'object',
    $id: 'search',
    properties: {
        and: {
            type: 'array',
            minItems: 1,
            items: {
                $ref: 'search',
            },
        },
        or: {
            type: 'array',
            minItems: 1,
            items: {
                $ref: 'search',
            },
        },
        not: {
            $ref: 'search',
        },
    },
    additionalProperties: SearchParamSchema,
};
exports.default = SearchSchema;
